'use client';
import { CreateDiscussionQuestionDialog } from '@/components/create-discussion-question-dialog';
import { DiscussionList } from '@/components/discussion-list';
import StartDiscussionComponent from '@/components/start-discussion-component';
import { Button } from '@/components/ui/button';
import { useSetupProfile } from '@/hooks/useSetupProfile';
import Link from 'next/link';
import { useMemo, useState } from 'react';

export default function Discussions() {
  const [
    showCreateDiscussionQuestionDialog,
    setShowCreateDiscussionQuestionDialog,
  ] = useState(false);
  const { getCategoriesApi } = useSetupProfile({
    loadCategories: true,
    filterType: 'DISCUSSIONS',
  });

  const categories = useMemo(() => {
    const grouped = Object.entries(getCategoriesApi.data?.data || {}).flatMap(
      ([key, value]) =>
        value.map((item) => ({
          value: item.id,
          label: item.name,
          description: item.description,
        }))
    );

    return grouped ?? [];
  }, [getCategoriesApi.data]);

  const isLoading = getCategoriesApi.isLoading;

  return (
    <section className="flex flex-col gap-4 p-8 max-w-6xl w-full mx-auto">
      <div className="flex justify-center gap-4 items-center">
        <StartDiscussionComponent />
        <Link href="/discussions/latest">
          <Button variant="outline" className="font-bold  uppercase">
            Join the conversation
          </Button>
        </Link>
        <Link href="/discussions/trending">
          <Button variant="outline" className="font-bold  uppercase">
            Trending discussions
          </Button>
        </Link>
      </div>
      <div className="flex justify-between items-center">
        <div className="flex flex-col gap-2">
          <h1 className="text-base font-bold text-[#24292E]">
            Explore Discussions
          </h1>
          <p className="text-sm text-gray-500">
            Browse topics of discussion that you like
          </p>
        </div>
      </div>

      {categories.length === 0 && !isLoading ? (
        <div className="flex items-center justify-center p-20">
          <p className="text-sm text-gray-500">No categories found.</p>
        </div>
      ) : (
        <DiscussionList categories={categories} isLoading={isLoading} />
      )}

      {showCreateDiscussionQuestionDialog && (
        <CreateDiscussionQuestionDialog
          open={showCreateDiscussionQuestionDialog}
          onOpenChange={setShowCreateDiscussionQuestionDialog}
        />
      )}
    </section>
  );
}
